document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelectorAll("#product_page_id").length > 0) {
    const user_localization = document.body.getAttribute("data-localization");
    const user_localizationcountry = document.body.getAttribute(
      "data-localizationcountry"
    );
    const checkAllInventory = (getVarId) => {
      var getVarId = getVarId;
      document
        .querySelectorAll(
          "#custom_product_deatils_grid .custom_product_deatils_item"
        )
        .forEach(function (cusOption) {
          var getId = cusOption.getAttribute("data-vid");
          if (getId === getVarId) {
            var adddElement = cusOption.querySelector(".unable_variant");
            if (adddElement) {
              adddElement.textContent = "unavailable";
              adddElement.style.display = "inline-block";
            }
            cusOption.style.opacity = "0.5";
            cusOption.style.pointerEvents = "none";
          }
        });
    };
    const checkAllLocation = () => {
      setTimeout(function () {
        var getActiveVar = document.querySelector(
          ".product-form .form .product-variant-id"
        )?.value;
        document
          .querySelectorAll("#product_Location_append > option")
          .forEach(function (option) {
            var getVarId = option.getAttribute("value");
            var location_id = option.getAttribute("data-locationid");
            var location_qty = option.getAttribute("data-locationqty");
            var location_policy = option.getAttribute("data-locationpolicy");
            if (user_localizationcountry == "United Kingdom") {
              if (location_id == "71404454051") {
                if (location_qty == 0 && location_policy == "DENY") {
                  if (getActiveVar == getVarId) {
                    document
                      .querySelectorAll(
                        '.product-form__submit[name="add"] span'
                      )
                      .forEach(function (element) {
                        element.textContent = "Sold out";
                      });
                    document
                      .querySelectorAll('.product-form__submit[name="add"]')
                      .forEach(function (element) {
                        element.setAttribute("disabled", "disabled");
                      });
                  }
                  checkAllInventory(getVarId);
                }
              }
            }
            if (user_localizationcountry == "United States") {
              if (location_id == "74500472995") {
                if (location_qty == 0 && location_policy == "DENY") {
                  if (getActiveVar == getVarId) {
                    document
                      .querySelectorAll(
                        '.product-form__submit[name="add"] span'
                      )
                      .forEach(function (element) {
                        element.textContent = "Sold out";
                      });
                    document
                      .querySelectorAll('.product-form__submit[name="add"]')
                      .forEach(function (element) {
                        element.setAttribute("disabled", "disabled");
                      });
                  }
                  checkAllInventory(getVarId);
                }
              }
            }
          });
      }, 500);
    };
console.log('erty',1,user_localizationcountry);
    if (
      user_localizationcountry == "United Kingdom" ||
      user_localizationcountry == "United States"
    ) {
      let productId = document
        .getElementById("product_page_id")
        .getAttribute("data-get");
      if (productId) {
        var variant_id = {
          id: "gid://shopify/Product/" + productId,
        };
        if (variant_id) {
          fetch(
            "https://dev.shopifyexperthelp.com/itgeekstraining/whiplash/quantity_available.php",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(variant_id),
            }
          )
            .then((response) => response.json())
            .then((resdata) => {
              console.log("Customer logout tracked:", resdata);
              resdata.data.forEach(function (location) {
                let location_title = location.title;
                let variant_id = location.variant_id
                  .replace("gid://shopify/ProductVariant/", "")
                  .trim();
                let location_name = location.name;
                let location_qty = location.quantity;
                let location_id = location.location_id
                  .replace("gid://shopify/Location/", "")
                  .trim();
                let location_policy = location.inventoryPolicy;
                $("#product_Location_append").append(
                  '<option class="optionList" data-locationname="' +
                    location_name +
                    '" data-locationqty="' +
                    location_qty +
                    '"  data-locationid="' +
                    location_id +
                    '" data-locationpolicy="' +
                    location_policy +
                    '" value="' +
                    variant_id +
                    '">' +
                    location_title +
                    "</option>"
                );

                // console.log("Name: " + location_name);
                // console.log("Quantity: " + location_qty);
                // console.log("Location ID: " + location_id);
                // console.log("Inventory Policy: " + location_policy);
                // console.log("variant_id: " + variant_id);
                // console.log("location_title: " + location_title);
                // console.log("---------------------------");
              });
              checkAllLocation();
            })
            .catch((error) => {
              console.error("Error tracking logout:", error);
            });
        }

        document
          .querySelectorAll(".quantity__button")
          .forEach(function (button) {
            button.addEventListener("click", function () {
              var customProductDetailsItem = this.closest(
                ".custom_product_deatils_item"
              );
              if (customProductDetailsItem) {
                var productInfo = document.querySelector(
                  ".product__info-container"
                );
                var society_variant = customProductDetailsItem.getAttribute(
                  "data-society-releases"
                );
                if (society_variant) {
                  productInfo.classList.add("active-society-variant");
                } else {
                  productInfo.classList.remove("active-society-variant");
                }
                var quantityInput =
                  customProductDetailsItem.querySelector(".quantity__input");
                if (quantityInput) {
                  var value_id =
                    customProductDetailsItem.getAttribute("data-vid");
                  var variant_qty = quantityInput.value;
                  document
                    .querySelectorAll("#product_Location_append > option")
                    .forEach(function (option) {
                      var getVarId = option.getAttribute("value");
                      var location_id = option.getAttribute("data-locationid");
                      var location_qty =
                        option.getAttribute("data-locationqty");
                      var location_policy = option.getAttribute(
                        "data-locationpolicy"
                      );

                      if (user_localizationcountry == "United Kingdom") {
                        if (location_id == "71404454051") {
                          if (getVarId == value_id) {
                            document
                              .querySelectorAll(
                                '.product-form__submit[name="add"] span'
                              )
                              .forEach(function (element) {
                                element.textContent = "Add to cart";
                              });
                            document
                              .querySelectorAll(
                                '.product-form__submit[name="add"]'
                              )
                              .forEach(function (element) {
                                element.removeAttribute("disabled", "disabled");
                              });
                          }
                        }
                      }

                      if (user_localizationcountry == "United States") {
                        if (location_id == "74500472995") {
                          if (getVarId == value_id) {
                            document
                              .querySelectorAll(
                                '.product-form__submit[name="add"] span'
                              )
                              .forEach(function (element) {
                                element.textContent = "Add to cart";
                              });
                            document
                              .querySelectorAll(
                                '.product-form__submit[name="add"]'
                              )
                              .forEach(function (element) {
                                element.removeAttribute("disabled", "disabled");
                              });
                          }
                        }
                      }
                    });
                }
              }
            });
          });
      }
    }
  }
  const variantList = document.querySelector(".mobile_varient_dropdown ul");
  if (variantList) {
    const infoContainer = document.querySelector(".product__info-container");
    variantList.addEventListener("click", function (e) {
      const clickedItem = e.target.closest("li");
      if (!clickedItem || !variantList.contains(clickedItem)) return;
      const hasSocietyAttr = clickedItem.dataset.societyReleases === "True";
      if (hasSocietyAttr) {
        infoContainer.classList.add("active-society-variant");
      } else {
        infoContainer.classList.remove("active-society-variant");
      }
    });
  }
});

$(document).ready(function () {
  // BANNER
  var $status_1 = $(".counter-info");
  var $slickElement_1 = $(".custom_bannner_head");

  $slickElement_1.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var x = (currentSlide ? currentSlide : 0) + 1;
      $status_1.html(
        '<span class="current_slide">' +
          x +
          '</span> / <span class="total_slides"> ' +
          slick.slideCount +
          "</span>"
      );
    }
  );

  $(".custom_bannner_head").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    prevArrow:
      '<span class="Arrowleft slide_arrow page-width"><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.00977 13L0.997143 7L8.00977 1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.01989 7L20.7202 7" stroke="white" stroke-linecap="round"/></svg></span>',
    nextArrow:
      '<span class="ArrowRight slide_arrow page-width"><svg width="21" height="14" viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.2871 1L20.2997 7L13.2871 13" stroke="white" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.277 7L0.57666 7" stroke="white" stroke-linecap="round"/></svg></span>',
    adaptiveHeight: true,
  });

  $(".slick-slider").on("click", ".slick-slide", function (e) {
    e.stopPropagation();
    var index_1 = $(this).data("slick-index");
    if ($(".slick-slider").slick("slickCurrentSlide") !== index_1) {
      $(".slick-slider").slick("slickGoTo", index_1);
    }
  });

  // SLIDER IMAGE WITH TEXT
  var $status = $(".img_width_text_counter_info");
  var $slickElement = $(".image_with_text_slide_head");

  $slickElement.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.html(
        '<span class="current_slide">' +
          i +
          '</span> / <span class="total_slides"> ' +
          slick.slideCount +
          "</span>"
      );
    }
  );

  $(".image_with_text_slide_head").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    prevArrow:
      '<span class="Arrowleft slide_arrow page-width"><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.00977 13L0.997143 7L8.00977 1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.01989 7L20.7202 7" stroke="white" stroke-linecap="round"/></svg></span>',
    nextArrow:
      '<span class="ArrowRight slide_arrow page-width"><svg width="21" height="14" viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.2871 1L20.2997 7L13.2871 13" stroke="white" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.277 7L0.57666 7" stroke="white" stroke-linecap="round"/></svg></span>',
    adaptiveHeight: true,
  });

  $(".slick-slider").on("click", ".slick-slide", function (e) {
    e.stopPropagation();
    var index = $(this).data("slick-index");
    if ($(".slick-slider").slick("slickCurrentSlide") !== index) {
      $(".slick-slider").slick("slickGoTo", index);
    }
  });

  // CARD PRODUCT
  $(document).on("mouseover", ".itg_card_wrapper", function () {
    $(".product_card_details_head").removeClass("product_card_details_active");
    var Value_1 = $(this).attr("Product-Title");
    $(".product_card_details_head").each(function () {
      var Value_2 = $(this).attr("Product-Details");
      if (Value_1 == Value_2) {
        $(this).addClass("product_card_details_active");
      }
    });
  });
  $(document).on("mouseleave", ".itg_card_wrapper", function () {
    $(this)
      .find(".product_card_details_head")
      .removeClass("product_card_details_active");
  });

  // FOOTER-NEWSLETTER
  $(document).on("click", ".newsletter_checkbox", function () {
    if ($(".newsletter_checkbox").attr("checked", true)) {
      $(this)
        .parents(".footer-block__newsletter")
        .find(".newsletter-form__button")
        .attr("disabled", false);
    }
  });

  // PRODUCT-PAGE TAB
  $(
    ".custom_tab_title_item:first , .product_custom_tab_content:first "
  ).addClass("tab_active");
  $(".custom_tab_title_item").click(function () {
    $(this).addClass("tab_active").siblings().removeClass("tab_active");
    var value_1 = $(this).attr("Data-Title");
    $(".product_custom_tab_content").each(function () {
      var value_2 = $(this).attr("Data-Content");
      if (value_1 == value_2) {
        $(this).addClass("tab_active");
      } else {
        $(this).removeClass("tab_active");
      }
    });
  });

  // PRODUCT PAGE READ MORE
  $(".readmore").click(function (event) {
    event.preventDefault();
    $(".product-description-full").css("display", "block");
    $(".product-description-short").css("display", "none");
  });

  $(".readless").click(function (event) {
    event.preventDefault();
    $(".product-description-full").css("display", "none");
    $(".product-description-short").css("display", "block");
  });

  // PRODUCT DETAILS
  // Set initial values and styles
  // $('.quantity').find(".quantity__input").val(0);
  $(".custom_product_deatils_item_available").find(".quantity__input").val(1);
  $(".custom_product_deatils_item_available")
    .siblings()
    .find(".quantity__input")
    .val(0);

  //$(".custom_product_deatils_item").find(".quantity").css("opacity", "0.5");
  $(".custom_product_deatils_item_available").find(".quantity").css("opacity", "1");

  // Event listener for quantity button click
  $(document).on("click", ".quantity__button_plus", function () {
    // Change opacity of the current item's quantity
    $(this)
      .parents(".custom_product_deatils_item")
      .find(".quantity")
      .css("opacity", "1");
    // Set opacity of siblings' quantities to 0.5
    $(this)
      .parents(".custom_product_deatils_item")
      .siblings()
      .find(".quantity")
    //  .css("opacity", "0.5");

    // Get the Product Variant ID
    var Varient_Id = $(this)
      .parents(".custom_product_deatils_item")
      .find(".quantity")
      .attr("Product_varinet_id");
    //$(".product-variant-id").val(Varient_Id);

    // Reset the quantity of sibling items to 0
    var value_blank = 0;
    $(this)
      .parents(".custom_product_deatils_item")
      .siblings()
      .find(".quantity")
      .find(".quantity__input")
     // .val(value_blank);

    // Update the secretly quantity input with the current item's quantity
    var varient_qty = $(this)
      .parents(".custom_product_deatils_item")
      .find(".quantity__input")
      .val();
    $(".secrectly_quantity__input").val(varient_qty);
  });

  // MOBILE VAIRNET DROPDWON
  var product_varinet_value_1 = $(".product_varinet_value_1").html();
  $(".mobile_dropdown_varinet_display").html(product_varinet_value_1);
  $(document).on("click", "li.product_varinet_value", function () {
    //console.log('change');
    var varinet_unique_id = $(this).attr("product_varinet_data");
    console.log(varinet_unique_id);
   // $(".product-variant-id").val(varinet_unique_id);
    var varine_data = $(this).html();
    $(this)
      .parents(".mobile_varient_dropdown")
      .find(".mobile_dropdown_varinet_display")
      .html(varine_data);
    $(this).parents().find("#ProductVarientSelect").slideUp();
  });

  $(document).on("click", ".mobile_dropdown_varinet_display", function () {
    $("#ProductVarientSelect").slideToggle();
  });

  // ARTISTS DIRECTORY TAB
  $("li.artists_directory_tab_title:first").addClass("tab_active");
  $("ul.artists_directory_tab_content_grid:first").addClass("tab_active");
  $(".featured_artist_wrapper:first")
    .children(".featured_artist_tab_head")
    .show();
  $("li.artists_directory_tab_title").click(function () {
    $(this).addClass("tab_active").siblings().removeClass("tab_active");
    var value_1 = $(this).attr("Tab-Title");
    $("ul.artists_directory_tab_content_grid , .featured_artist_tab_head").each(
      function () {
        var value_2 = $(this).attr("Tab-Content");
        if (value_1 == value_2) {
          $(this).show();
          $("html,body").animate({
            scrollTop: $("#featured_artists").offset().top,
          });
        } else {
          $(this).hide();
        }
      }
    );
  });

  $("a.scroll_to_top").click(function () {
    $("html,body").animate(
      {
        scrollTop: $(".secretly_mega_menu_wrapper").offset().top,
      },
      2000
    );
  });

  // $(".artists_directory_tab_title").click(function() {
  //   $('html,body').animate({
  //       scrollTop: $("#featured_artists").offset().top},2000);
  // });

  // MOBILE ARTIST-DIRECTORY DROPDWON
  if ($(window).width() < 750) {
    var Active_Tab_Value_1 = $("li.artists_directory_tab_title:first").text();
    $(".mobile_dropdown_active_tab").text(Active_Tab_Value_1);
    $(document).on(
      "click",
      ".artists_directory_mobile_dropdown_head",
      function () {
        $(this).siblings().slideToggle();
        $(".custom-down-arrow").css("rotate", "180deg");
      }
    );

    $(document).on("click", "li.artists_directory_tab_title", function () {
      var Artists_Directory_Tab_Title = $(this).text();
      console.log(Artists_Directory_Tab_Title);
      $(".mobile_dropdown_active_tab").text(Artists_Directory_Tab_Title);
      $(this).parents("ul.artists_directory_tab_title_grid").slideUp();
      $(".custom-down-arrow").css("rotate", "360deg");
    });
  }

  // $('ul.artists_directory_tab_title_grid').slick({
  // dots: false,
  // infinite: true,
  // speed: 300,
  // slidesToShow: 4,
  // slidesToScroll: 1,
  // responsive: [
  //     {
  //       breakpoint: 750,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         dots: true,
  //       }
  //     }
  //   ]
  // });

  $("ul.artist_thumb_slider_images_head").slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  });

  // ARTIST-PAGE-THUMB-PAGE
  var Thumb_1_ImgSrc = $(".artist_thumb_slider_image_1")
    .children("img")
    .attr("src");
  $(".artist_main_thumb_images").attr("src", Thumb_1_ImgSrc);
  $(document).on("click", ".artist_thumb_slider_image", function () {
    var ThumbImgSrc = $(this).children("img").attr("src");
    $(".artist_main_thumb_images").attr("src", ThumbImgSrc);
  });

  // ARTIST-PAGE READ MORE
  $(".readmore").click(function (event) {
    event.preventDefault();
    $(".artist_page_description-full").css("display", "block");
    $(".artist_page_description-short").css("display", "none");
  });

  $(".readless").click(function (event) {
    event.preventDefault();
    $(".artist_page_description-full").css("display", "none");
    $(".artist_page_description-short").css("display", "block");
  });

  // LOAD MORE
  // $(".load-more").show();
  // $(".artist_featured_collection_wrapper ul li.grid__item").hide();
  // $(".artist_featured_collection_wrapper ul li.grid__item").slice(0, 8).show();
  // $("#Laod_more_btn").on("click", function () {
  //   $(".artist_featured_collection_wrapper ul li.grid__item:hidden")
  //     .slice(0, 8)
  //     .slideDown("2500");
  //   var Current_Product_Count = $(".Product_Show").text();
  //   $(".Product_Show").text(8 + parseInt(Current_Product_Count));
  //   if (
  //     $(".artist_featured_collection_wrapper ul li.grid__item:hidden").length ==
  //     0
  //   ) {
  //     $(".load-more").hide();
  //   }
  // });

  $(
    ".custom-products_with_tab_wrapper li.products_tab_title_item:first"
  ).addClass("tab_active");
  $(
    ".custom-products_with_tab_wrapper ul.tab__products_list_grid:first"
  ).addClass("tab_active");
  $(
    ".secretly-product-release-tab-wrapper li.products_tab_title_item:last"
  ).addClass("tab_active");
  $(
    ".secretly-product-release-tab-wrapper ul.tab__products_list_grid:last"
  ).addClass("tab_active");
  $("li.products_tab_title_item").click(function () {
    $(this).addClass("tab_active").siblings().removeClass("tab_active");
    let value_1 = $(this).attr("Tab-Title");
    $("ul.tab__products_list_grid").each(function () {
      let value_2 = $(this).attr("Tab-Content");
      if (value_1 == value_2) {
        $(this).addClass("tab_active");
      } else {
        $(this).removeClass("tab_active");
      }
    });
  });

  // CONTACT WITH ACCORDION
  $(".accordion_head:first .accodion_heading_head").addClass(
    "downlaod_accordion_active"
  );
  $(".accordion_head:first .accodion_content").slideDown();
  $(".accodion_heading_head").on("click", function () {
    const DataTitle = $(this).attr("DataTitle");
    $(".accodion_content").each(function () {
      const DataContent = $(this).attr("DataContent");
      if (
        $(this)
          .parents(".accordion_head")
          .find(".accodion_heading_head")
          .hasClass("downlaod_accordion_active")
      ) {
        $(this)
          .parents(".accordion_head")
          .find(".accodion_heading_head")
          .removeClass("downlaod_accordion_active");
        $(this).slideUp();
      } else {
        if (DataTitle == DataContent) {
          $(this)
            .parents(".accordion_head")
            .find(".accodion_heading_head")
            .addClass("downlaod_accordion_active");
          $(this).slideToggle();
        } else {
          $(this)
            .parents(".accordion_head")
            .find(".accodion_heading_head")
            .removeClass("downlaod_accordion_active");
          $(this).slideUp();
        }
      }
    });
  });

  // SITE-NAVIGATION-CHILD
  $(".store-navigation-childlink").click(function () {
    $(this)
      .children("span")
      .css("color", "#f39b1e")
      .parents(".store-navigation-childlink")
      .siblings()
      .children("span")
      .css("color", "#828282");
    let NavigationChildlink = $(this).attr("id");
    let StoreHeadingID = $(this)
      .parents()
      .find("#" + NavigationChildlink)
      .attr("id");
    if (NavigationChildlink == StoreHeadingID) {
      $("html, body").animate(
        {
          scrollTop: $("#" + StoreHeadingID).offset().top - 50,
        },
        500
      );
    }
  });

  // SITE-NAVIGATION-LINK
  $(".store-navigation-text").each(function () {
    let navID = $(this).attr("id");
    let pageHandle = $(".store-navigation-wrapper").attr("id");
    let nav_Active = pageHandle.includes(navID);
    if (nav_Active) {
      $(this).children("a").addClass("navigation_active");
    }
  });

  // MOBILE ARTIST-DIRECTORY DROPDWON
  if ($(window).width() < 750) {
    $(".store-navigation-head").hide();
    $(document).on("click", ".mobile_store_navigation_head", function () {
      $(this)
        .parents(".store-navigation-wrapper")
        .find(".store-navigation-head")
        .slideToggle();
    });
  }

  var Get_Product_Count = [18];
  $(document).on("click", ".load-more_btn", function () {
    let Product_Count = parseInt($(this).attr("Data-Count"));
    Get_Product_Count.push(Product_Count);
    var i;
    var total_product_page_Count = 0;
    for (i = 0; i < Get_Product_Count.length; ++i) {
      console.log(i);
      total_product_page_Count += Get_Product_Count[i];
      $(".no_of_product_on_page").text(total_product_page_Count);
    }
  });
});